import React, { useState } from 'react';
import { Nav } from 'react-bootstrap';
import ReporteVentas from './componentes/reporteVentas';
import ReporteCompras from './componentes/reporteCompras';
import ReporteIngresos from './componentes/reporteIngresos';
import ReporteGastos from './componentes/reporteGastos';
import ReporteHistorial from './componentes/reporteHistorial';
function AdminReportes() {
    const [activeKey, setActiveKey] = useState('/active');

    const renderContent = () => {
        switch (activeKey) {
            case '/active':
                return <ReporteVentas />;
            case 'link-compras':
                return <ReporteCompras />;
            case 'link-ingresos':
                return <ReporteIngresos />
            case 'link-gastos':
                return <ReporteGastos />
            case 'link-historial':
                return <ReporteHistorial />;
            default:
                return null;
        }
    };

    return (
        <>
            <div>
                <Nav variant="tabs" fill defaultActiveKey="/active" onSelect={(selectedKey) => setActiveKey(selectedKey)}>
                    <Nav.Item>
                        <Nav.Link eventKey="/active" className='text-center w-100 d-flex justify-content-center align-items-center'>Ventas</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="link-compras" className='text-center w-100 d-flex justify-content-center align-items-center'>Compras</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="link-ingresos" className='text-center w-100 d-flex justify-content-center align-items-center'>Ingresos</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="link-gastos" className='text-center w-100 d-flex justify-content-center align-items-center'>Gastos</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="link-historial" className='text-center w-100 d-flex justify-content-center align-items-center'>Historial</Nav.Link>
                    </Nav.Item>
                </Nav>
                <div>
                    {renderContent()}
                </div>
            </div>
        </>
    )
}

export default AdminReportes;